import { observer } from 'mobx-react-lite';

import { EmptyState } from '@components/empty-state';
import { IconSearch } from '@components/icons/search';

import { useStore } from 'models/Provider';

export const EmptyApplicationResult = observer((props: { isFiltered?: boolean }) => {
  const { isFiltered } = props;

  const { t } = useStore();
  const heading = isFiltered ? t('job.applicants.empty.search') : t('job.applicants.empty');
  const message = isFiltered ? t('job.applicants.msg.search') : t('job.applicants.msg.all');
  return <EmptyState content={message} header={heading} icon={<IconSearch size={80} />} />;
});
